



























































import { Component } from 'vue-property-decorator';
import { AuthModule } from '@/store/Auth/AuthModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';

@Component({ name: 'UserPermissions' })
export default class extends SaascadaVue {

    dialog: boolean = false;

    get isGlobalAdmin() {
        return AuthModule.me.globalAdmin;
    }

    get permissions() {
        return AuthModule.me.permissions;
    }

    get paymentOrderApprovalLimit() {
        return AuthModule.me.paymentOrderApprovalLimit;
    }

    get paymentOrderApprovalNotificationLowerLimit() {
        return AuthModule.me.paymentOrderApprovalNotificationLowerLimit;
    }

    close() {
        this.dialog = false;
    }

};
